import { ICommand } from 'projects/game-utils/src/lib/controller/ICommand';
import { State } from 'projects/game-utils/src/lib/controller/StateFile';
import { Message } from 'projects/game-utils/src/lib/utils/Message';
import { SocketService } from 'projects/game-utils/src/lib/service/socket.service';

export class SendLogin implements ICommand{

    constructor(private socketService:SocketService){

    }

    getState():number{
        return State.NOT_LOGGED;
    }

    run(msg:Message, params:Array<any>):void {
        var login:string = msg.params[0];
        //FlexGlobals.topLevelApplication.parameters.login;
        let m:Message = new Message();
        m.fromServer = false;
        m.name = "login";
        m.params[0] = login;
        m.params[1] = this.socketService.flashvars.newPostponedToken;//msg.params[1];
        
        //FlexGlobals.topLevelApplication.parameters.newPostponedToken;
        m.receiver = "server";
        m.sender = login;
        this.socketService.sendMsg(m);
    }
}